import React, { Component } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";
import ReferralHash from "../../../common/referral-hash";

import { incrementReferral } from "screens/new/requests/increment-referral";

import HomeView from "screens/new/component/view";
import axios from "axios";

class Home extends Component {
  constructor(props) {
    super(props);

    const {
      location: { search },
    } = props;

    let hash = null;

    if (search) {
      hash = queryString.parse(search.replace("+", "%2B")).referral_hash;

      if (hash) {
        localStorage.setItem("referral_hash", hash);
        incrementReferral(hash);
      }
    }

    if (!hash) {
      hash = localStorage.getItem("referral_hash");
    }

    ReferralHash.hash = hash;

    axios({
      method: "POST",
      url: "/api/v2/link-url",
      data: { url: window.location.href },
    });
  }

  getCookie(name) {
    let cookies = `; ${document.cookie}`;
    let parts = cookies.split(`; ${name}=`);

    return parts.length === 2 && parts.pop().split(";").shift();
  }

  render() {
    return <HomeView />;
  }
}

Home.propTypes = {
  location: PropTypes.object,
};

export default Home;
